// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const photoGallery = {
    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
        this.bindSlider();
    },

    bindUI: function() {
        this.ui.sliders = document.querySelectorAll(".js-photoGallerySlider");
    },

    bindEvents: function() {},

    bindSlider: function() {
        const sliderParams = {
            "1_cover": {
                slidesPerView: 1,
                spaceBetween: 30,
                containerModifierClass: 'js-photoGallerySlider',
                wrapperClass: 'js-photoGallery-wrapper',
                slideClass: 'js-photoGallery-slide',
                watchOverflow: true,
                navigation: {
                    nextEl: '.js-photoGallery-nav-next',
                    prevEl: '.js-photoGallery-nav-prev',
                },
                pagination: {
                    el: '.js-photoGallery-pagination',
                    clickable: true,
                    // dynamicBullets: true,
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                },
            },
            "1_contain": {
                slidesPerView: 1,
                spaceBetween: 20,
                containerModifierClass: 'js-photoGallerySlider',
                wrapperClass: 'js-photoGallery-wrapper',
                slideClass: 'js-photoGallery-slide',
                watchOverflow: true,
                navigation: {
                    nextEl: '.js-photoGallery-nav-next',
                    prevEl: '.js-photoGallery-nav-prev',
                },
                pagination: {
                    el: '.js-photoGallery-pagination',
                    clickable: true,
                    // dynamicBullets: true,
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        navigation: false,
                    },
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                },
            },
            "2": {
                slidesPerView: 2,
                spaceBetween: 40,
                containerModifierClass: 'js-photoGallerySlider',
                wrapperClass: 'js-photoGallery-wrapper',
                slideClass: 'js-photoGallery-slide',
                navigation: {
                    nextEl: '.js-photoGallery-nav-next',
                    prevEl: '.js-photoGallery-nav-prev',
                },
                pagination: {
                    el: '.js-photoGallery-pagination',
                    clickable: true,
                    // dynamicBullets: true,
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        navigation: false,
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                },
            },
            "3": {
                slidesPerView: 3,
                spaceBetween: 40,
                containerModifierClass: 'js-photoGallerySlider',
                wrapperClass: 'js-photoGallery-wrapper',
                slideClass: 'js-photoGallery-slide',
                navigation: {
                    nextEl: '.js-photoGallery-nav-next',
                    prevEl: '.js-photoGallery-nav-prev',
                },
                pagination: {
                    el: '.js-photoGallery-pagination',
                    clickable: true,
                    // dynamicBullets: true,
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        navigation: false,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
            },
        };
        this.ui.sliders.forEach(slider => {
            let sliderType = slider.dataset.sliderType;
            let index = slider.dataset.loopIndex;

            if (sliderParams.hasOwnProperty(sliderType)) {
                let sliderConfig = sliderParams[sliderType];

                // For the nav we must set a unique index so they are not shared between all sliders in the page
                sliderConfig.navigation = {
                    nextEl: '.js-photoGallery-nav-next--'+index,
                    prevEl: '.js-photoGallery-nav-prev--'+index,
                };

                new Swiper(slider, sliderConfig);
            } else {
                console.log('ne marche pas', sliderType);
            }
        });
    },
};

export default photoGallery;